'use strict';

import WindowView from 'standard-vote/app/scripts/views/window.js';

module.exports = WindowView;



// WEBPACK FOOTER //
// ./app/scripts/views/window.js